import {createContext} from "react";

export const WMSContext = createContext({
    currentMemberAuthorizations: null,
    currentMember: null,
    currentInventory: null,
    currentOrganization: null,
    preferredPrinter: {},
    preferredPackingStation: {},
    currentTask: null,
    isMobile: false,
    setPreferredPrinter: (printer) => {},
    setPreferredPackingStation: (container) => {},
    setCurrentTask: (task) => {},
    groupWmsItemsBySku: (wmsItems) => {},
    getItemTotalPrice: (wmsItem) => {},
    redirect: (path) => {}
})
